import { ViewStateContainer } from "@is/contexts";

export type SettingsViewState = {
  showConnectScannerModal: boolean;
  showIFramePage: boolean;
  showPasscodeView: boolean;
  showStoreFavoritesView: boolean;
  showCollectionsModal: boolean;
  showResumeParkedBasketModal: boolean;
};

export type SettingsViewStateContainer = ViewStateContainer<SettingsViewState>;

export const initialSettingsViewState: SettingsViewState = {
  showConnectScannerModal: false,
  showIFramePage: false,
  showPasscodeView: true,
  showStoreFavoritesView: false,
  showCollectionsModal: false,
  showResumeParkedBasketModal: false,
};
